import presentationChat from './chat.module'

export default {
  presentationChat,
  // more sub-modules for presentation-related things
}
